export const validateArrayField = (value: any[]) =>
  value.length === 0 && "Campo requerido.";
